"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingEventStatus = void 0;
var TrackingEventStatus;
(function (TrackingEventStatus) {
    TrackingEventStatus["PRE_TRANSIT"] = "PRE_TRANSIT";
    TrackingEventStatus["SORTATION_ARRIVAL"] = "SORTATION_ARRIVAL";
    TrackingEventStatus["IN_TRANSIT"] = "IN_TRANSIT";
    TrackingEventStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
    TrackingEventStatus["DELIVERED"] = "DELIVERED";
    TrackingEventStatus["RETURN_TO_SENDER"] = "RETURN_TO_SENDER";
    TrackingEventStatus["AVAILABLE_FOR_PICKUP"] = "AVAILABLE_FOR_PICKUP";
    TrackingEventStatus["RETURN_INITIATED"] = "RETURN_INITIATED";
    TrackingEventStatus["RETURN_COMPLETED"] = "RETURN_COMPLETED";
    TrackingEventStatus["FAILURE"] = "FAILURE";
    TrackingEventStatus["CANCELED"] = "CANCELED";
    TrackingEventStatus["UNKNOWN"] = "UNKNOWN";
})(TrackingEventStatus = exports.TrackingEventStatus || (exports.TrackingEventStatus = {}));
//# sourceMappingURL=PackageTrackingDetail.js.map